import { render } from "./OfferPage.vue?vue&type=template&id=1f2cc718&ts=true"
import script from "./OfferPage.vue?vue&type=script&lang=ts"
export * from "./OfferPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__